import { render, staticRenderFns } from "./totalPoints.vue?vue&type=template&id=f3e08dc6"
import script from "./totalPoints.vue?vue&type=script&lang=ts"
export * from "./totalPoints.vue?vue&type=script&lang=ts"
import style0 from "./totalPoints.vue?vue&type=style&index=0&id=f3e08dc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports